import cookPipelineLead from './cookPipelineLead.js';

const cookPipelineLeads = (pipelineLeads = [], pipelines = []) => {
  for (let i = 0; i < pipelineLeads.length; i++) {
    pipelineLeads[i] = cookPipelineLead(pipelineLeads[i], pipelines);
  }
  return pipelineLeads;
};

export default cookPipelineLeads;
